import React from 'react';
import { Box } from '@mui/material';
import MDTypography from 'components/MDTypography';
import { useMaterialUIController } from "context";

const InfoCard = ({ value, label }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <Box
      sx={{
        textAlign: 'center',
        background: darkMode 
          ? 'linear-gradient(195deg, rgba(66, 165, 245, 0.08), rgba(25, 118, 210, 0.08))'
          : 'linear-gradient(195deg, rgba(66, 165, 245, 0.04), rgba(25, 118, 210, 0.04))',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid',
        borderColor: darkMode ? 'rgba(66, 165, 245, 0.15)' : 'rgba(66, 165, 245, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100px',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: darkMode 
            ? '0 8px 16px rgba(66, 165, 245, 0.2)' 
            : '0 8px 16px rgba(66, 165, 245, 0.15)',
        },
      }}
    >
      <MDTypography
        variant="h4"
        fontWeight="bold"
        color="info"
        sx={{ mb: 0.5 }}
      >
        {value || '0'}
      </MDTypography>
      <MDTypography
        variant="button"
        fontWeight="medium"
        sx={{ opacity: 0.8 }}
      >
        {label}
      </MDTypography>
    </Box>
  );
};

export default InfoCard;

